import React from 'react';
import { useSelector } from 'react-redux';
import { isToolActiveSelector } from '../../tool/selectors/tool.selectors';
import { Tool } from '../../tool/utils/tool.utils';
import { Box } from '@cdl/heartbeat-react';
import { squareToPixel } from '../../plot/utils/graph.utils';
import { useStrip } from '../../plot/hooks/useStrip';
import {
  episodeMeasurementMetricSelector,
  episodeMeasurementRangeSelector,
} from '../selectors/episode-measurement.selectors';
import { computeInterval } from '../utils/episode-measurement.utils';

const INFO_WIDTH = squareToPixel(4);
const INFO_HEIGHT = squareToPixel(2);
const FONTSIZE = '1.25rem';

export const EpisodeMeasurementInfo: React.FC = () => {
  const { xScale, height } = useStrip();
  const isEpisodeMeasurementActive = useSelector(
    isToolActiveSelector(Tool.episodeMeasurement),
  );
  const episodeMeasurementInfo = useSelector(episodeMeasurementMetricSelector);
  const [start, end] = useSelector(episodeMeasurementRangeSelector);
  const episodeMeasurementDuration = computeInterval(start, end);
  const x = start + episodeMeasurementDuration / 2;
  if (
    episodeMeasurementDuration === 0 ||
    !isEpisodeMeasurementActive ||
    !episodeMeasurementInfo
  ) {
    return <></>;
  }

  return (
    <foreignObject
      width={INFO_WIDTH}
      height={INFO_HEIGHT}
      x={xScale(x) - INFO_WIDTH / 2}
      y={height - squareToPixel(1.5)}
    >
      <Box
        display='flex'
        justifyContent='center'
        alignItems='center'
        height='2.5rem'
        borderRadius='4px'
        bgColor='neutral.300'
        color='neutral.0'
        fontSize={FONTSIZE}
        style={{ opacity: 0.9, userSelect: 'none' }}
        data-testid='ruler-info'
      >
        {episodeMeasurementInfo}
      </Box>
    </foreignObject>
  );
};
